import { render, staticRenderFns } from "./add.vue?vue&type=template&id=0fafa616&scoped=true"
import script from "./add.vue?vue&type=script&setup=true&lang=js"
export * from "./add.vue?vue&type=script&setup=true&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=0fafa616&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fafa616",
  null
  
)

export default component.exports